import { Notification } from 'components/Notification/Notification';
import React from 'react';
import PasswordValidationHint from 'components/ValidationHint/PasswordValidationHint';
import {
  MIN_PASSWORD_LEN,
  validatePasswordCase1,
  validatePasswordCase2,
  validatePasswordCase3,
  validatePasswordCase4,
} from 'helpers/signup.helpers';
import './FloatingPasswordValidator.scss';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

export const PasswordValidationCmp = props => {
  const {
    datatestid,
    passwordFocused,
    password,
    submitError,
    showPreviousPasswordWarning,
    positionRelative,
  } = props;

  let classnameInner = 'passwordValidationSection pad16';
  if (positionRelative) {
    classnameInner =
      'passwordValidationSectionRelative pad16 format100 pos-rel borderRad4 bgWhite';
  }
  if (passwordFocused) {
    return (
      <div className={classnameInner}>
        <PasswordValidation
          datatestid={datatestid}
          password={password}
          submitError={submitError}
          showPreviousPasswordWarning={showPreviousPasswordWarning}
        />
      </div>
    );
  } else {
    return null;
  }
};

export const PasswordValidation = function ({
  submitError,
  password,
  datatestid,
  showPreviousPasswordWarning,
}) {
  return (
    <FlexContainer
      datatestid={`${datatestid}-passwordValidationHints`}
      className="flex-column"
    >
      <Label
        datatestid={`${datatestid}-passwordValidationTitle`}
        type="Subtitle-2"
        className="padB8"
      >
        Password must have:
      </Label>
      <PasswordValidationHint
        message={`Minimum ${MIN_PASSWORD_LEN} characters`}
        datatestid={`${datatestid}-loginSecurityPwLengthCheck`}
        submitted={submitError}
        passed={validatePasswordCase1(password)}
      />
      <PasswordValidationHint
        message="1 uppercase letter"
        submitted={submitError}
        datatestid={`${datatestid}-loginSecurityPwUpperCaseCheck`}
        passed={validatePasswordCase2(password)}
      />
      <PasswordValidationHint
        message="1 lowercase letter"
        datatestid={`${datatestid}-loginSecurityPwLowerCaseCheck`}
        submitted={submitError}
        passed={validatePasswordCase3(password)}
      />
      <PasswordValidationHint
        message="1 number"
        datatestid={`${datatestid}-loginSecurityPwLowerCaseCheck`}
        submitted={submitError}
        passed={validatePasswordCase4(password)}
      />
      {showPreviousPasswordWarning && (
        <>
          <div className="margT8" />
          <Notification
            type="info"
            id={1}
            isInline={true}
            title={
              <Label type="Body-2">
                Your new password must be different from your last 4 passwords.
              </Label>
            }
            open={true}
            notClosable={true}
            transient={true}
          />
        </>
      )}
    </FlexContainer>
  );
};

const FloatingPasswordValidator = props => {
  const { datatestid, positionRelative } = props;

  let classname = 'FloatingPasswordValidator';
  if (positionRelative) {
    classname = 'FloatingPasswordValidatorRelative pos-rel top5';
  }

  return (
    <div data-testid={`${datatestid}`} className={classname}>
      <PasswordValidationCmp {...props} />
    </div>
  );
};

export default FloatingPasswordValidator;
